export default "__VITE_ASSET__071234c0__"